import type { Matter } from "@/lib/types";

export const getRelatedMatterSelectionOptions = (matter: Matter) =>
  Array.from(
    new Map(
      matter.relatedMatterConnections
        .filter((connection) => connection.relatedMatterId !== matter.id)
        .map((connection) => [
          connection.relatedMatterId,
          {
            clientId: connection.clientId ?? null,
            clientName: connection.clientName ?? null,
            id: connection.relatedMatterId,
            title:
              connection.title ||
              connection.relatedMatterTitle ||
              "Untitled matter",
          },
        ]),
    ).values(),
  );
